import { render, staticRenderFns } from "./AutocompleteOdontogramas.vue?vue&type=template&id=26f61a7f"
import script from "./AutocompleteOdontogramas.vue?vue&type=script&lang=js"
export * from "./AutocompleteOdontogramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports